import { ApiProduct } from '@vend/types'
import filter from 'lodash/filter'
import { store } from '../../factories/database/database'
import {
  useProductEmbeddedBarcodeService,
  useRetailerSettingsManager,
  useSyncManager,
} from '../../ng-compat/hooks'
import { isProductActive } from '../../factories/search/product-index-util'

export interface BarcodeProductResult {
  product: ApiProduct
  barcodeData: string
}

export const useProductBarcodeSearch = () => {
  const syncManager = useSyncManager()
  const retailerSettings = useRetailerSettingsManager()
  const productEmbeddedBarcodeService = useProductEmbeddedBarcodeService()
  const productsIndexDB = store('products').index('byProductCode')

  return async (query: string): Promise<BarcodeProductResult | undefined> => {
    // Wait until products have been synced.
    await new Promise<void>((resolve, reject) =>
      syncManager
        .whenCompleteEntityDataAvailable('products')
        .then(() => resolve())
        .catch(err => reject(err))
    )

    // Has the retailer set up barcode embedded price, or quanity/weight?
    const retailerBarcodeSetting = retailerSettings.getBarcodeOption()

    if (
      !retailerBarcodeSetting ||
      retailerBarcodeSetting === 'none' ||
      !productEmbeddedBarcodeService.isEmbeddedBarcode(query)
    ) {
      return
    }

    // The components are the SKU and the embedded data if any.
    const barcodeComponents = productEmbeddedBarcodeService.extractComponents(
      query
    )

    if (!barcodeComponents) {
      return
    }

    const rawProducts = await productsIndexDB.getAll(
      String(barcodeComponents.SKU)
    )
    // Filter inactive products.
    const filteredProducts = filter(rawProducts, isProductActive)
    const resultProducts = filteredProducts.map((product: ApiProduct) => {
      return {
        product,
        barcodeData: barcodeComponents.PriceOrWeight,
      }
    })

    if (resultProducts.length > 0) {
      // Product codes are unique.
      return resultProducts[0]
    }
  }
}
